<script setup lang="ts">
defineProps({
    error: {
        type: String,
        default: "",
    },
});
</script>

<template>
    <div v-show="error">
        <p class="input__error">
            {{ error }}
        </p>
    </div>
</template>

<style lang="scss" scoped>
.input__error {
    border: none;
    color: $error;
    font-weight: 700;
    font-size: 0.75rem;
}
</style>
